declare global {
    export interface HTMLElement {
        findFirst(selector: string): HTMLElement | null;
        findParents(selector: string): HTMLElement | null;
        ifExistThen(callback: Function): void; 
        hide(): void;
        display(display?: string): void;
        setInnerText(value?: string): void;
        setInnerHtml(value?: string): void;
        setValue(value?: string): void;
        removeClass(className: string): void;
        addClass(className: string): void;
        containClass(className: string): boolean;
        style: any;
        dataset: any;
        value: any;
    }
}

export class DomExtensions {

    constructor(containerName?: string) {
        const ctx = this;
        HTMLElement.prototype.findFirst = function (selector: string) {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }
            
            return ctx.findFirst(this, selector);
        };

        HTMLElement.prototype.findParents = function (selector: string) {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }
            
            return ctx.findParents(this, selector);
        };

        HTMLElement.prototype.ifExistThen = function (callback: Function) {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }
            
            return ctx.ifExistThen(this, callback);
        };

        HTMLElement.prototype.removeClass = function (className: string) {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }

            return ctx.removeClass(this, className);
        };

        HTMLElement.prototype.addClass = function (className: string) {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }

            return ctx.addClass(this, className);
        };

        HTMLElement.prototype.containClass = function (className: string) {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }

            return ctx.containClass(this, className);
        };

        HTMLElement.prototype.display = function (display?: string) {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }

            return ctx.display(this, display);
        };

        HTMLElement.prototype.setInnerText = function (value?: string) {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }

            return ctx.setInnerText(this, value);
        };

        HTMLElement.prototype.setInnerHtml = function (value?: string) {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }

            return ctx.setInnerHtml(this, value);
        };

        HTMLElement.prototype.setValue = function (value?: string) {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }

            return ctx.setValue(this, value);
        };

        HTMLElement.prototype.hide = function () {
            if (containerName && !this.classList.contains(containerName) && !this.closest('.' + containerName)) {
                return null;
            }
            
            return ctx.hide(this);
        };
    }

    public findFirst(container: HTMLElement, selector: string): HTMLElement | null {
        return container.querySelector(selector);
    }

    public findParents(me: HTMLElement, selector: string): HTMLElement | null {

        const recursiveUp = (e: HTMLElement): any => {
            if (e.parentElement) {
                if (selector[0] === '.') {
                    const cls = selector.replace('.', '');
                    if (e.parentElement.classList.contains(cls)) {
                        return e.parentElement;
                    }
                } else if (selector[0] === '#') {
                    const id = selector.replace('#', '');
                    if (e.parentElement.id == id) {
                        return e.parentElement;
                    }
                }

                return recursiveUp(e.parentElement);
            }

            return null;
        }

        return recursiveUp(me);
    }

    public ifExistThen(element: HTMLElement, callback: Function) {
        element && callback(element);
    }

    public addClass(element: HTMLElement, className: string) {
        element && element.classList.add(className);
    }

    public removeClass(element: HTMLElement, className: string) {
        element && element.classList.remove(className);
    }

    public containClass(element: HTMLElement, className: string): boolean {
        return element && element.classList.contains(className);
    }

    public display(element: HTMLElement, display?: string) {
        if (element) {
            element.style.display = (display ? display : 'block');
        }
    }

    public setInnerText(element: HTMLElement, value?: string) {
        if (element) {
            element.innerText = (value ? value : '');
        }
    }

    public setInnerHtml(element: HTMLElement, value?: string) {
        if (element) {
            element.innerHTML = (value ? value : '');
        }
    }

    public setValue(element: HTMLElement, value?: string) {
        if (element) {
            element.value = (value ? value : '');
        }
    }

    public hide(element: HTMLElement) {
        if (element) {
            element.style.display = 'none';
        }
    }

    public castTo<T>(node: Node | ChildNode | Element | HTMLElement | NodeListOf<Element>): T {
        const html: any = node;
        const htmlElement: T = html;
        return htmlElement;
    }
}